var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoginMobileBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 367,
  height: 123,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#36bdb6",
  strokeWidth: 1.25,
  opacity: 0.49
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M.625-12.297h21.25v21.25H.625zM23.125 10.203h21.25v21.25h-21.25zM68.125 10.203h21.25v21.25h-21.25z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36bdb6",
  fillOpacity: 0.2,
  d: "M45.625-12.297h21.25v21.25h-21.25zM90.625 32.703h21.25v21.25h-21.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.125 55.203h21.25v21.25h-21.25zM158.125 55.203h21.25v21.25h-21.25zM135.625 32.703h21.25v21.25h-21.25z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36bdb6",
  fillOpacity: 0.2,
  d: "M180.625 77.703h21.25v21.25h-21.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.125 100.203h21.25v21.25h-21.25z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36bdb6",
  fillOpacity: 0.2,
  d: "M248.125 100.203h21.25v21.25h-21.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M225.625 77.703h21.25v21.25h-21.25zM45.625 77.703h21.25v21.25h-21.25zM68.125 100.203h21.25v21.25h-21.25zM113.125 100.203h21.25v21.25h-21.25zM90.625 77.703h21.25v21.25h-21.25zM135.625-12.297h21.25v21.25h-21.25zM158.125 10.203h21.25v21.25h-21.25z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36bdb6",
  fillOpacity: 0.2,
  d: "M203.125 10.203h21.25v21.25h-21.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.625-12.297h21.25v21.25h-21.25z",
  opacity: 0.1
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M381.875 53.953h-21.25v-21.25h21.25z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36bdb6",
  fillOpacity: 0.2,
  d: "M359.375 31.453h-21.25v-21.25h21.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M336.875 8.953h-21.25v-21.25h21.25z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36bdb6",
  fillOpacity: 0.2,
  d: "M291.875 8.953h-21.25v-21.25h21.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M314.375 31.453h-21.25v-21.25h21.25zM381.875 98.953h-21.25v-21.25h21.25z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36bdb6",
  fillOpacity: 0.2,
  d: "M336.875 98.953h-21.25v-21.25h21.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359.375 121.453h-21.25v-21.25h21.25z",
  opacity: 0.1
})))));
export { SvgLoginMobileBg as ReactComponent };
export default __webpack_public_path__ + "7ba1aee5f3ce5cd46528d42736df502e.svg";